import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldAi: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-ai, security, safety, privacy, cyber"><path d="M3.75 5.75L12 2.25L20.25 5.75V13C20.25 17.5563 16.5563 21.25 12 21.25C7.44365 21.25 3.75 17.5563 3.75 13V5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.4 7.9541H11.6L10.6 10.5541L8 11.5541V12.3541L10.6 13.3541L11.6 15.9541H12.4L13.4 13.3541L16 12.3541V11.5541L13.4 10.5541L12.4 7.9541Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShieldAi;
